<template>
  <div>
    <van-nav-bar
      :title="getInfo"
      left-text="退出"
      left-arrow
      @click-left="exit"
    />

    <van-card
      v-if="this.$cookies.get('user') === 'teacher'"
      :desc="this.$cookies.get('info').gender+' '+this.$cookies.get('info').tNum"
      :title="this.$cookies.get('info').tName"
      thumb="http://cdn.sport.hhstu.xyz/%E5%AD%A6%E7%94%9F.png"

    >
      <template #footer>
        <van-button @click="changePwd" type="info" size="mini">修改密码</van-button>
      </template>
    </van-card>

    <van-collapse v-model="activeName" accordion>
      <van-collapse-item size="large" title="数据查看" name="1">
        <van-cell-group>
          <van-cell title="课堂人数" :value="course_a"/>
          <van-cell title="已选课人数" :value="course_c"/>
          <van-cell title="俱乐部规划人数" :value="club_a"/>
          <van-cell title="已选俱乐部人数" :value="club_c"/>
          <van-cell title="场馆总规划人数" :value="venue_a"/>
          <van-cell title="场馆总预约人数" :value="venue_c"/>
          <van-cell title="今日预约上限" :value="venue_n_a"/>
          <van-cell title="今日实际预约" :value="venue_n_c"/>
          <van-cell title="今日进馆训练总数" :value="exercise_n"/>
        </van-cell-group>
        <div style="padding: 30px">
          <van-button type="primary" size="large" @click="StatisInfo">数据查看</van-button>
        </div>
      </van-collapse-item>
      <van-collapse-item v-show="this.$cookies.get('user') === 'admin'" size="large" title="开放控制" name="2">
        <van-cell center title="课程开放退出">
          <template #right-icon>
            <van-switch @change="ControlInfo" v-model="courseQuit" size="24"/>
          </template>
        </van-cell>
        <van-cell center title="俱乐部开放退出">
          <template #right-icon>
            <van-switch @change="ControlInfo" v-model="clubQuit" size="24"/>
          </template>
        </van-cell>
        <van-field
          readonly
          clickable
          :value="startTime"
          name="startUnixTime"
          label="学期开始时间"
          placeholder="点击选择本学期开始时间"
          @click="startTimeShowPicker = true"
        />

        <van-popup v-model="startTimeShowPicker" position="bottom">
          <van-datetime-picker
            v-model="currentDate"
            type="date"
            title="点击选择本学期开始时间"
            :min-date="minDate"
            :max-date="maxDate"
            @confirm="startOnConfirm"
            @cancel="startTimeShowPicker = false"
          />
        </van-popup>
      </van-collapse-item>

      <van-collapse-item v-show="this.$cookies.get('user') === 'teacher'" size="large" title="我的小组" name="3">
        <van-tabs v-model="active" @click="gradeClick">
          <van-tab title="2021级" name="2021">
            <div v-for="(item,index) in Sophomore">
              <van-swipe-cell>
                <van-card
                  :desc="item.week+item.times"
                  :title="item.course+' '+item.teacher"
                  class="goods-card"
                  thumb="http://icon.hhstu.club/logo.jpg"
                  @click="CardClick(item)"
                >
                  <template #tags>
                    总人数:{{ item.all }},选择俱乐部人数:{{ item.select }}
                    <br>
                    总时长:{{ item.alltime }}小时,平均时长:{{ item.avg }}小时
                  </template>
                  <template #footer>
                    完成率:{{ item.rate }}%
                  </template>
                </van-card>
              </van-swipe-cell>
              <van-progress :percentage="item.rate" style="margin: 10px"/>
            </div>
          </van-tab>
          <van-tab title="2020级" name="2020">
            <div v-for="(item,index) in Freshman">
              <van-swipe-cell>
                <van-card
                  :desc="item.week+item.times"
                  :title="item.course+' '+item.teacher"
                  class="goods-card"
                  thumb="http://icon.hhstu.club/logo.jpg"
                  @click="CardClick(item)"
                >
                  <template #tags>
                    总人数:{{ item.all }},选择俱乐部人数:{{ item.select }}
                    <br>
                    总时长:{{ item.alltime }}小时,平均时长:{{ item.avg }}小时
                  </template>
                  <template #footer>
                    完成率:{{ item.rate }}%
                  </template>
                </van-card>
              </van-swipe-cell>
              <van-progress :percentage="item.rate" style="margin: 10px"/>
            </div>
          </van-tab>
        </van-tabs>
      </van-collapse-item>

      <van-collapse-item size="large" title="全校排名" name="4">
        <van-tabs v-model="active" @click="allRankClick">
          <van-tab title="2021级" name="2021">
            <van-divider v-show="top10.length>0"
                         :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }"
            >
              前十名
            </van-divider>
            <div v-for="(item,index) in top10">
              <van-swipe-cell>
                <van-card
                  :desc="item.week+item.times"
                  :title="item.course+' '+item.teacher"
                  class="goods-card"
                  thumb="https://img.yzcdn.cn/vant/apple-3.jpg"
                >
                  <template #tags>
                    总人数:{{ item.all }},选择俱乐部人数:{{ item.select }}
                    <br>
                    总时长:{{ item.alltime }}小时,平均时长:{{ item.avg }}小时
                  </template>
                  <template #footer>
                    完成率:{{ item.rate }}%
                  </template>
                </van-card>
              </van-swipe-cell>
              <van-progress :percentage="item.rate" style="margin: 10px"/>
            </div>
            <van-divider v-show="last10.length>0"
                         :style="{ color: '#ee0a24', borderColor: '#ee0a24', padding: '0 16px' }"
            >
              后十名
            </van-divider>
            <div v-for="(item,index) in last10">
              <van-swipe-cell>
                <van-card
                  :desc="item.week+item.times"
                  :title="item.course+' '+item.teacher"
                  class="goods-card"
                  thumb="https://img.yzcdn.cn/vant/apple-3.jpg"
                  @click="CardClick"
                >
                  <template #tags>
                    总人数:{{ item.all }},选择俱乐部人数:{{ item.select }}
                    <br>
                    总时长:{{ item.alltime }}小时,平均时长:{{ item.avg }}小时
                  </template>
                  <template #footer>
                    完成率:{{ item.rate }}%
                  </template>
                </van-card>
              </van-swipe-cell>
              <van-progress color="#ee0a24" :percentage="item.rate" style="margin: 10px"/>
            </div>
          </van-tab>
          <van-tab title="2020级" name="2020">
            <van-divider v-show="top10.length>0"
                         :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }"
            >
              前十名
            </van-divider>
            <div v-for="(item,index) in top10">
              <van-swipe-cell>
                <van-card
                  :desc="item.week+item.times"
                  :title="item.course+' '+item.teacher"
                  class="goods-card"
                  thumb="https://img.yzcdn.cn/vant/apple-3.jpg"
                >
                  <template #tags>
                    总人数:{{ item.all }},选择俱乐部人数:{{ item.select }}
                    <br>
                    总时长:{{ item.alltime }}小时,平均时长:{{ item.avg }}小时
                  </template>
                  <template #footer>
                    完成率:{{ item.rate }}%
                  </template>
                </van-card>
              </van-swipe-cell>
              <van-progress :percentage="item.rate" style="margin: 10px"/>
            </div>
            <van-divider v-show="last10.length>0"
                         :style="{ color: '#ee0a24', borderColor: '#ee0a24', padding: '0 16px' }"
            >
              后十名
            </van-divider>
            <div v-for="(item,index) in last10">
              <van-swipe-cell>
                <van-card
                  :desc="item.week+item.times"
                  :title="item.course+' '+item.teacher"
                  class="goods-card"
                  thumb="https://img.yzcdn.cn/vant/apple-3.jpg"
                  @click="CardClick"
                >
                  <template #tags>
                    总人数:{{ item.all }},选择俱乐部人数:{{ item.select }}
                    <br>
                    总时长:{{ item.alltime }}小时,平均时长:{{ item.avg }}小时
                  </template>
                  <template #footer>
                    完成率:{{ item.rate }}%
                  </template>
                </van-card>
              </van-swipe-cell>
              <van-progress color="#ee0a24" :percentage="item.rate" style="margin: 10px"/>
            </div>
          </van-tab>
        </van-tabs>
      </van-collapse-item>
      <van-collapse-item size="large" v-show="this.$cookies.get('user') === 'teacher'" title="成绩导入" name="5">
        <div style="text-align:center;">
          <van-uploader v-model="fileList" :max-count="1" :before-read="before_read"
                        :after-read="after_read" :before-delete="delete_file">
            <van-button round block icon="plus" type="primary">文件导入</van-button>
          </van-uploader>
        </div>
      </van-collapse-item>
      <van-collapse-item size="large" v-show="this.$cookies.get('user') === 'admin'" title="体测数据上传" name="6">
        <a target="_blank"
           href="https://files.sports.hhstu.club/%E4%BD%93%E6%B5%8B%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx">
          <van-button style="margin-bottom: 25px" round block type="warning">体测成绩导入模板下载</van-button>
        </a>
        <div style="text-align:center;">
          <van-uploader v-model="pt_fileList" :max-count="1" :before-read="pt_before_read"
                        :after-read="pt_after_read" :before-delete="pt_delete_file" accept=".xlsx">
            <van-button round block icon="plus" type="primary">体测成绩导入</van-button>
          </van-uploader>
        </div>
        <van-cell-group>
          <van-cell v-for="(item,index) in logs"
                    :title="`${item.utype} ${item.uname}`"
                    :value="new Date(item.createDate).toLocaleString()"
                    :label="item.des" key="index"/>
        </van-cell-group>
      </van-collapse-item>
    </van-collapse>
    <div style="margin-bottom: 50px"></div>

    <van-action-sheet position="top" v-model="CourseRankShow" :title="this.course+' '+this.times ">

      <van-cell-group>
        <van-cell v-for="(item,index) in students"
                  :title="item.name+' '+item.title" :value="'时长'+item.times+'分钟'"
                  :label="item.gender+' '+item.number" :key="index"/>
      </van-cell-group>

    </van-action-sheet>

    <van-action-sheet position="top" v-model="changePwdShow" title="修改密码">
      <van-form @submit="onChangePwdSubmit">
        <van-field
          v-model="oldPwd"
          type="password"
          name="oldPwd"
          label="原密码"
          placeholder="原密码"
          :rules="[{ required: true, message: '请填写原密码' }]"
        />
        <van-field
          v-model="newPwd"
          type="password"
          name="newPwd"
          label="新密码"
          placeholder="新密码"
          :rules="[{ required: true, message: '请填写新密码' }]"
        />
        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit">
            修改
          </van-button>
        </div>
      </van-form>


      <div style="margin-bottom: 50px"></div>
    </van-action-sheet>
  </div>
</template>

<script>
import Vue from 'vue'
import {
  NavBar, Calendar, Cell, CellGroup, Button,
  Dialog, Collapse, CollapseItem, Switch, Card,
  Tab, Tabs, SwipeCell, Progress, Divider, ActionSheet, Field, Form, Toast, Uploader, Popup, DatetimePicker
} from 'vant';
import {GetStatisInfo, GetControlInfo, ChangeControlInfo} from "@/network/admin";
import {AdminGetLogs} from "@/network/logs";
import {
  TeacherGetAllClubRank,
  TeacherGetClubRank,
  TeacherGetClubRankInCourse,
  TeacherChangePassword
} from "@/network/teacher";
import {upLoadStuScore, upLoadStuPhysicalTest} from "@/network/upLoader";

Vue.use(NavBar);
Vue.use(Calendar);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Button);
Vue.use(Dialog);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Switch);
Vue.use(Card);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(SwipeCell);
Vue.use(Progress);
Vue.use(Divider);
Vue.use(ActionSheet);
Vue.use(Field);
Vue.use(Form);
Vue.use(Toast);
Vue.use(Uploader);
Vue.use(Popup);
Vue.use(DatetimePicker);
export default {
  name: "Profile",
  data() {
    return {
      course_a: 0,
      course_c: 0,
      club_a: 0,
      club_c: 0,
      venue_a: 0,
      venue_c: 0,
      venue_n_a: 0,
      venue_n_c: 0,
      exercise_n: 0,

      activeName: '0',

      clubQuit: false,
      courseQuit: false,

      //Rush term time
      startTime: '',
      startTimeShowPicker: false,
      currentDate: new Date(),
      minDate: new Date(2022, 1, 1),
      maxDate: this.GLOBAL.end_select_time,
      startUnixTime: '',

      //Tab
      active: "2019",
      Freshman: [],
      Sophomore: [],
      top10: [],
      last10: [],

      //ActionSheet
      CourseRankShow: false,
      course: "",
      times: "",
      students: [],

      //action sheet
      changePwdShow: false,
      oldPwd: "",
      newPwd: "",

      // upload
      fileList: [],
      // 体测upload
      pt_fileList: [],

      logs: []
    };
  },
  activated() {
    if (this.$cookies.get('user') === 'admin') {
      GetControlInfo().then(res => {
        if (res.club === 0)
          this.clubQuit = false;
        else if (res.club === 1)
          this.clubQuit = true;

        if (res.course === 0)
          this.courseQuit = false;
        else if (res.course === 1)
          this.courseQuit = true;

        this.startTime = new Date(res.startDate).toLocaleDateString();
        this.startUnixTime = new Date(res.startDate).getTime();
      })
    }
    AdminGetLogs().then(res => {
      this.logs = res;
    })
  },
  computed: {
    getInfo() {
      if (this.$cookies.get("user") === "admin") {
        return "管理员欢迎您";
      } else if (this.$cookies.get("user") === "teacher") {
        return this.$cookies.get('info').tName + " 欢迎您";
      } else {
        return "请退出重新登录";
      }
    },
  },
  methods: {
    exit() {
      Dialog.confirm({
        title: '提示',
        message: '确定退出账号吗',
      }).then(() => {
        this.$cookies.remove("islogin");
        this.$cookies.remove("user");
        this.$cookies.remove("info");
        this.$router.replace("/login")
        location.reload();
      }).catch(() => {
      });

    },
    StatisInfo() {
      GetStatisInfo().then(res => {
        this.course_a = res.course_a;
        this.course_c = res.course_c;
        this.club_a = res.club_a;
        this.club_c = res.club_c;
        this.venue_a = res.venue_a;
        this.venue_c = res.venue_c;
        this.venue_n_a = res.venue_n_a;
        this.venue_n_c = res.venue_n_c;
        this.exercise_n = res.exercise_n;
      })
    },
    ControlInfo() {
      ChangeControlInfo(this.courseQuit ? 1 : 0, this.clubQuit ? 1 : 0, this.startUnixTime);
    },
    CardClick(item) {
      this.course = item.course;
      this.times = item.week + item.times;
      this.CourseRankShow = true;
      TeacherGetClubRankInCourse(item.cid).then(res => {
        this.students = res;
      });
    },
    gradeClick(name) {
      TeacherGetClubRank(name).then(res => {
        if (name === '2019')
          this.Sophomore = res;
        else
          this.Freshman = res;
      })
    },
    allRankClick(name) {
      this.top10 = [];
      this.last10 = [];
      TeacherGetAllClubRank(name).then(res => {
        this.top10 = res.top10;
        this.last10 = res.last10;
      })
    },
    changePwd() {
      this.changePwdShow = true;
    },
    onChangePwdSubmit(values) {
      Dialog.confirm({
        title: '提示',
        message: '确定要修改吗'
      }).then(() => {
        TeacherChangePassword(values.oldPwd, values.newPwd).then(res => {
          if (res.status) {
            Toast.success('修改成功');
            let info = this.$cookies.get('info');
            info.pwd = values.newPwd;
            this.$cookies.set("info", info, '6m');
          } else {
            Toast.fail(res.message);
          }
        })
      });
    },
    before_read(file) {
      // console.log(file);
      let fileTypes = file.name.split('.');
      let fileType = fileTypes[fileTypes.length - 1];
      if (fileType !== 'xlsx' && fileType !== 'xls') {
        Dialog.alert({
          message: '请上传 xlsx或xls 格式文件',
        });
        return false;
      } else if (file.size > 5039264) {
        Dialog.alert({
          message: '文件过大,请保持在5M以内',
        });
        return false;
      }
      return true;
    },
    after_read(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      let data = new FormData();
      data.append("file", file.file);
      upLoadStuScore(data).then(res => {
        if (res.status) {
          file.status = 'done';
          file.message = '导入成功';
          Dialog.alert({
            title: '导入分数信息',
            message: '成功:' + res.success + ',失败:' + res.fail,
          });
        } else {
          file.status = 'failed';
          file.message = '导入失败';
        }
      }).catch(res => {
        file.status = 'failed';
        file.message = '导入失败';
      })

    },
    delete_file() {
      this.FailStudentList = [];
      return true;
    },
    pt_before_read(file) {
      // console.log(file);
      let fileTypes = file.name.split('.');
      let fileType = fileTypes[fileTypes.length - 1];
      if (fileType !== 'xlsx' && fileType !== 'xls') {
        Dialog.alert({
          message: '请上传 xlsx或xls 格式文件',
        });
        return false;
      } else if (file.size > 10039264) {
        Dialog.alert({
          message: '文件过大,请保持在10M以内',
        });
        return false;
      }
      return true;
    },
    pt_after_read(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      let data = new FormData();
      data.append("file", file.file);
      upLoadStuPhysicalTest(data).then(res => {
        if (res.status) {
          file.status = 'done';
          file.message = '导入或更新成功';
          AdminGetLogs().then(res => {
            this.logs = res;
          })
          Dialog.alert({
            title: '导入信息',
            message: '导入或更新成功:' + res.success + ',失败:' + res.fail,
          });
        } else {
          file.status = 'failed';
          file.message = '导入失败';
        }
      }).catch(res => {
        file.status = 'failed';
        file.message = '导入失败';
      })

    },
    pt_delete_file() {
      this.FailStudentList = [];
      return true;
    },
    startOnConfirm(value) {
      this.startUnixTime = value.getTime().toString();
      this.startTime = value.toLocaleDateString();
      this.startTimeShowPicker = false;

      this.ControlInfo();
    },
  }
}
</script>

<style scoped>
.goods-card {
  margin: 0;
  background-color: white;
}

.delete-button {
  height: 100%;
}
</style>
